<template>
  <div>
    <Nav-rgpd></Nav-rgpd>
    <div class="w-100 mt-5 col-11 p-5">
      <b-row class="d-flex" lg="12">
        <b-col lg="10" md="9">
          <PageHeader :title="title" class="mt-2"/>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-lg-12">
          <div class="card px-3">
            <div class="card-body">
              <form class="outer-repeater">
                <div data-repeater-list="outer-group" class="outer">
                  <div data-repeater-item class="outer" v-if="getRgpd">
                    <div v-html="editorModel" v-if="!show" class="col-12 w-100"></div>
                  </div>
                </div>
              </form>
              <div class="mt-4">
                <b-button variant="magenta" size="md" href="#" class="float-end btn-size magenta" @click="show=true"
                          v-if="show">
                  Enregistrer
                </b-button>
                <b-button variant="outline-dark" size="md" href="#" class="float-end btn-size me-4" @click="show=false"
                          v-if="show">
                  Annuler
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
  </div>
</template>

<script>

import NavRgpd from "@/components/nav-rgpd";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * Task-create component
 */
export default {
  page: {
    title: "Gestion RGPD",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {PageHeader, NavRgpd},
  data() {
    return {
      title: "Le règlement général sur la protection des données",
      editorModel: "",
      show: false,
      items: [
        {
          text: "",
          href: "",
        },
        {
          active: true,
        },
      ],
    }
  },
  created() {
    this.$store.dispatch("rgpd/contentRgpd");
  },
  methods: {
    matchData(data) {
      if (data[0]) {
        this.editorModel = data[0].content;
      }
    }
  },
  computed: {
    getRgpd() {
      let data = this.$store.getters["rgpd/getRgpd"];
      this.matchData(data)
      return data;
    },
  }
}
</script>

<style scoped lang="scss">
.card {
  height: auto !important;
}

</style>